import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth.service';
import { AppCommonService } from '../appcommon.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../LoaderService';
import { HeaderAndNavigationService } from '../headerandnavigation/headerandnavigation.service';
import { ILoggedUser, TokenModel } from '../headerandnavigation/loggeduser/loggeduser';
declare var $: any;
@Component({
  templateUrl: "./holding.component.html"
})
export class HoldingComponent implements OnInit, AfterViewInit, OnDestroy {


  constructor(private authService: AuthService,
    private router: Router,
    private appCommonService: AppCommonService,
    private loaderService: LoaderService,
    public headerAndNavigationService: HeaderAndNavigationService,
    private route: ActivatedRoute
  ) {
    this.appCommonService.pageContentAdditionalClass = "home-page holding-page";
  }




  ngOnInit() {
    $('#login').hide();
  }

  ngAfterViewInit() {
    const selfMe = this;
    selfMe.identityProcess();
  }

  ngOnDestroy() {

  }

  identityProcess() {

    if (typeof location !== "undefined" && window.location.hash) {
      setTimeout(() => {
        let isAuthorized = sessionStorage.getItem(("_isAuthorized_" + this.authService.clientId));

        if (!isAuthorized) {
          window.location.reload();
        }
        if (isAuthorized) {
          this.loaderService.display(true);
         
          this.initialLoadCalls();
        }
      }, 2500);

    }
    else {
      let userData = JSON.parse(sessionStorage.getItem(("userData_" + this.authService.clientId)));
      if (userData == "" || userData === null) {
        setTimeout(() => {
        }, 2500);
      }
    }
  }



  initialLoadCalls() {

    let userData = JSON.parse(sessionStorage.getItem(("userData_" + this.authService.clientId)));
    let userId = userData.sub;
    let impId = localStorage.getItem(this.authService.mftImpersonationId)
    if (impId !== "" && impId !== null) {
      userId = impId;
    }
    this.authService.getIdentityLoggedUserFromAPI(userId)
      .subscribe(
        (user: ILoggedUser) => {

          user.applications_access = userData.applications_access;
          this.authService.setUser(user);
          this.authService.setUserRoles(user);
          let tokenModel: TokenModel = new TokenModel();
          tokenModel.access_token = this.authService.getUserToken()
          tokenModel.token_type = "bearer";
          tokenModel.expires_in = 3600;
          tokenModel.userName = "";
          console.log(user);
          tokenModel.userId = user.id;
          tokenModel.companyId = user.companyId;
          tokenModel.allowOrderNotes = user.allowOrderNotes;
          tokenModel.allowAlternateDeliveryAddress = user.allowAlternateDeliveryAddress;
          this.authService.saveToken(tokenModel);
          localStorage.setItem("mftAccessTokenLocalstorage", JSON.stringify(tokenModel));
          this.loaderService.display(false);
          this.redirectToRelevantAccessArea();
        },
        (error: any) => {

          this.headerAndNavigationService.showError("Logged user retrieval problem", <any>error);
          this.headerAndNavigationService.ClearUserData();
          this.router.navigate(['/noaccess']);
          this.loaderService.display(false);
        }
      );
  }

  redirectToRelevantAccessArea(): void {
    if (this.appCommonService.reDirectURL === '/login') {
      this.appCommonService.reDirectURL = '/home';
    }
    this.router.navigate([this.appCommonService.reDirectURL]);
  }

  public login() {
    this.authService.login();
  }
}



// WEBPACK FOOTER //
// ./src/app/genericpages/holding.component.ts